import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import { LineChart } from "@mui/x-charts/LineChart";
import * as React from "react";

// Simple line chart for average response time
export default function ResponseTimeChart({
  title = "Average Response Time",
  data = [],
  labels = [],
}) {
  const sampleData = data.length
    ? data
    : [2.5, 3.1, 2.8, 3.4, 2.9, 3.0, 2.7, 2.6, 3.2, 2.8, 2.9, 3.1];

  const sampleLabels = labels.length
    ? labels
    : [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

  return (
    <Box sx={{ height: "100%", border: "none" }}>
      <Typography
        variant="caption"
        sx={{ color: "text.secondary", mb: 2, display: "block" }}
      >
        How quickly the agent responds to new tickets
      </Typography>
      <LineChart
        xAxis={[{ scaleType: "point", data: sampleLabels }]}
        series={[
          {
            data: sampleData,
            label: "Hours",
            color: "#42a5f5",
          },
        ]}
        height={220}
        margin={{ left: 50, right: 20, top: 20, bottom: 20 }}
        grid={{ horizontal: true }}
        slotProps={{ legend: { hidden: true } }}
      />
    </Box>
  );
}
